import * as React from 'react';
import { RouteComponentProps, Prompt } from 'react-router-dom';
import { Input, ColorPicker } from '@progress/kendo-react-inputs';
import { fetchApi } from '../../services/api';
import * as moment from 'moment';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import InstructorTabs from './Tabs';
import LoadingButton from '../LoadingButton';
const DocumentTitle = require('react-document-title');

type InstructorProps = RouteComponentProps<{
    instructorId: string
}>

type State = {
    isLoading: boolean;
    isDirty: boolean;
    Validation: boolean;

    instructor: InstructorData | undefined;
}

type InstructorData = {
    FacilityID: number;
    InstructorId: number;
    Name: string;
    FirstName: string;
    LastName: string;
    InstructorNumber: string;
    Email: string;
    StartDate: Date;
    EndDate: Date;
    CalendarColor: string;
}

class Instructor extends React.Component<InstructorProps, State> {
    constructor(props: InstructorProps) {
        super(props);

        this.state = {
            isLoading: true,
            isDirty: false,
            Validation: false,
            instructor: undefined,
        }

        this.save = this.save.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let instructorId = parseInt(this.props.match.params.instructorId) || 0;
        this.requestInstructor(instructorId);
    }

    public componentWillReceiveProps(nextProps: InstructorProps) {
        // This method runs when incoming props (e.g., route params) change
        let instructorId = parseInt(nextProps.match.params.instructorId) || 0;

        if (this.state.instructor && this.state.instructor.InstructorId != instructorId) {
            this.requestInstructor(instructorId);
        }
    }

    public render() {
        return <React.Fragment>
            {this.state.instructor && (this.state.instructor.InstructorId != 0) && <InstructorTabs instructorId={this.state.instructor.InstructorId} history={this.props.history} instructor />}
            {this.state.instructor &&
                <div className="k-form">
                    <DocumentTitle title={this.state.instructor.Name || "New Instructor"} />
                    <Prompt when={this.state.isDirty} message="Unsaved changes will be lost, are you sure?" />
                    {this.state.isLoading && <div className="k-loading-image"></div>}
                    <h5>Instructor Information</h5>
                    <label className="k-form-field">
                        <span>First Name<span style={{ color: '#dc3545' }}>*</span></span>
                        <Input
                            type="text"
                            placeholder="First Name"
                            value={this.state.instructor.FirstName}
                            onChange={(e) => this.updateInstructorState({ FirstName: e.target.value })}
                        />
                        {this.state.Validation && !this.state.instructor.FirstName && <p className="error-msg">Instructor First Name is Required</p>}
                    </label>
                    <label className="k-form-field">
                        <span>Last Name<span style={{ color: '#dc3545' }}>*</span></span>
                        <Input
                            type="text"
                            placeholder="Last Name"
                            value={this.state.instructor.LastName}
                            onChange={(e) => this.updateInstructorState({ LastName: e.target.value })}
                        />
                        {this.state.Validation && !this.state.instructor.LastName && <p className="error-msg">Instructor Last Name is Required</p>}
                    </label>
                    <label className="k-form-field">
                        <span>Email<span style={{ color: '#dc3545' }}>*</span></span>
                        <Input
                            type="text"
                            placeholder="E-Mail"
                            value={this.state.instructor.Email}
                            onChange={(e) => this.updateInstructorState({ Email: e.target.value })}
                        />
                        {this.state.Validation && !this.state.instructor.Email && <p className="error-msg">Instructor E-Mail is Required</p>}
                    </label>
                    <label className="k-form-field">
                        <span>I.d.</span>
                        <Input
                            type="text"
                            placeholder="Identification Number"
                            value={this.state.instructor.InstructorNumber}
                            onChange={(e) => this.updateInstructorState({ InstructorNumber: e.target.value })}
                        />
                    </label>
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Start Date<div style={{ color: '#dc3545' }}>*</div></span>
                        </div>
                        <DatePicker
                            format="MM/dd/yyyy"
                            defaultValue={moment().toDate()}
                            name={`StartDate`}
                            formatPlaceholder="formatPattern"
                            value={this.state.instructor.StartDate}
                            onChange={(e) => this.updateInstructorState({ StartDate: e.value })}
                        />
                    </div>
                    <br />
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">End Date&nbsp;<div style={{ color: '#dc3545' }}>*</div></span>
                        </div>
                        <DatePicker
                            format="MM/dd/yyyy"
                            defaultValue={moment().toDate()}
                            name={`EndDate`}
                            formatPlaceholder="formatPattern"
                            value={this.state.instructor.EndDate}
                            onChange={(e) => this.updateInstructorState({ EndDate: e.value })}
                        />
                    </div>
                    {(this.state.Validation && !this.state.instructor.EndDate) ? <p className="error-msg">End Date is Required</p> : <br />}
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Calendar Color</span>
                        </div>
                        <ColorPicker
                            view="combo"
                            value={this.state.instructor.CalendarColor || undefined}
                            onChange={(e) => this.updateInstructorState({ CalendarColor: this.rgb2hex(e.value) })}
                            gradientSettings={{ opacity: false }}
                            paletteSettings={{ 
                                palette:["#f44336","#e91e63","#9c27b0","#673ab7","#3f51b5","#2196f3","#03a9f4","#00bcd4","#009688","#4caf50","#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#9e9e9e", "#607d8b", "#fc80ab"]
                            }}
                        />
                    </div>
                    <br />
                    <div className="text-right">
                        <LoadingButton 
                            onClick={this.save}
                            disabled={!this.state.isDirty}
                            isLoading={this.state.isLoading}
                            isLoadingText="Saving..."
                            className="btn btn-primary"
                        >
                            {this.state.instructor.InstructorId === 0 ? 'Create' : 'Save'}
                        </LoadingButton>
                    </div>
                </div>
            }
        </React.Fragment>;
    }

    private rgb2hex(rgba: string) {
        const rgb = rgba.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
        return (rgb && rgb.length === 4) ? "#" +
            ("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : '';
    }

    private updateInstructorState(value: Partial<InstructorData>) {
        const instructor = Object.assign({}, this.state.instructor, value);
        this.setState({ instructor, isDirty: true });
    }

    private requestInstructor(instructorId: number) {
        this.setState({ isLoading: true });
        fetchApi(`api/Instructor/Get/${instructorId}`)
            .then((instructor: InstructorData) => {
                instructor.StartDate = instructor.StartDate ? moment.utc(instructor.StartDate).toDate() : null;
                instructor.EndDate = instructor.StartDate ? moment.utc(instructor.EndDate).toDate() : null;
                this.setState({ isLoading: false, isDirty: false, instructor });
            });
    }

    private save() {
        this.setState({ Validation: true }, () => {
            if (this.state.instructor && document.getElementsByClassName("error-msg").length === 0) {
                this.setState({ isLoading: true });
                if (this.state.instructor.InstructorId > 0) {
                    fetchApi(`api/Instructor/Save/${this.state.instructor.InstructorId}`, this.state.instructor, 'POST')
                        .then(() => {
                            this.setState({ isLoading: false, isDirty: false });
                        });
                } else {
                    fetchApi(`api/Instructor/Create/`, this.state.instructor, 'POST')
                        .then((response: { InstructorID: number }) => {
                            this.updateInstructorState({ InstructorId: response.InstructorID });
                            this.setState({ isLoading: false, isDirty: false });

                            this.props.history.push("/instructors");
                        });
                }
            }
        });
    }
}

export default Instructor;
